/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospect1Inputs */

const en_coinvestments_prospect1 = /** @type {(inputs: Coinvestments_Prospect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prospect`)
};

/**
* | output |
* | --- |
* | "prospect" |
*
* @param {Coinvestments_Prospect1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospect1 = /** @type {((inputs?: Coinvestments_Prospect1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospect1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospect1(inputs)
});
export { coinvestments_prospect1 as "coInvestments_prospect" }